import React, { useState, useEffect } from 'react';
import { IconRange } from '../Utilities/Range';
import _default from 'react-bootstrap/esm/Accordion';


export default class Outils extends React.Component {

	state = {
		open: false,
		selected: null,
		recordPendingStart: false,
		recordPending: false,
		volume: {},
		doc2uState: this.props.doc2uState,
		doc2uActivated: false,
		recordStarted: false,
		volume: {}
	};

	outils = [];
	
	processRawDevices(rawDevices) {
        let devices = [];
        for(var i in rawDevices) {
            devices.push({
                data: rawDevices[i],
                status: 'closed'
            })
        }

        let rawScreenDevices = window.sdk.videoconf().getScreenDevices();

        let screenDevices = [];
        for(var i in rawScreenDevices) {
            screenDevices.push({
                data: rawScreenDevices[i],
                status: 'closed'
            })
        }
		this.outils = JSON.parse(JSON.stringify(window.sdk.settings().devices));
		let doc2uIndex = -1;

		for(var i in this.outils) {
			const deviceResult = devices.find(({ data }) => data.slug === this.outils[i].slug && data.label.startsWith(this.outils[i].label));

			const deviceScreenResult = screenDevices.find(({ data }) => data.slug === this.outils[i].slug && data.label.startsWith(this.outils[i].label));
			console.log('this.outils[i].role', JSON.stringify(this.outils[i]));
			if (this.outils[i].role === "Doc2u" && !this.state.doc2uState && !rawDevices.find((item) => item.role === 'Doc2u')) {
				//this.outils.pop(i);
				//it's better to pop after the loop
				console.log('ici doc2u');
				doc2uIndex = i;
				continue;
			}
			if(!deviceResult && !deviceScreenResult && this.outils[i].role != "Doc2u")
				this.outils[i].enable = false;
			else {
				this.outils[i].enable = true;	
				if(deviceResult)		
					this.outils[i].device = deviceResult;
				else
					this.outils[i].device = deviceScreenResult;
			}

			this.outils[i].iconId = this.outils[i].role.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(' ','-');
			if(this.outils[i].screen) {
				this.outils[i].actions = [
					{
						type: 'camera',
					},
					{
						type: 'record',
					},
				];
			}
			if(this.outils[i].video) {
				this.outils[i].actions = [
					{
						type: 'camera',
					},
					{
						type: 'record',
					},
				];
			}
			if(this.outils[i].audio) {
				if(!this.outils[i].screen) {
					this.outils[i].actions = [
						{
							type: 'record',
						},
					];
				}
				this.outils[i].configs = [
					{
						type: 'slider',
						icon: 'speaker',
					},
				];
			}
		}

		if(doc2uIndex != -1) {
			this.outils.splice(doc2uIndex, 1);
		}
    }

    async componentDidMount() {

		window.sdk.event().on('volumeChangeFromVolumeControl', (icon, value) => {
			this.onVolumeChange(icon, value)
		})

        window.sdk.event().on('availableRemoteDevices', async (devices) => {                       
            let rawDevices = await window.sdk.videoconf().getSpecificDevices(); 
			console.log('availableRemoteDevices', rawDevices)
			console.log('rawDevices 3')
            this.processRawDevices(rawDevices);    			
			this.forceUpdate();                    
        })

		window.sdk.event().on('deviceChange', async () => {
            let rawDevices = await window.sdk.videoconf().getSpecificDevices(); 
			console.log('rawDevices 2')
            this.processRawDevices(rawDevices);
			this.forceUpdate();    
        })

		window.sdk.event().on('screenshare-workflow-started', () => {
            window.sdk.event().emit('modalOpen', {
				variant: 'alert',
				title: 'Partage d\'écran',
				content: 'Le patient a déjà débuté un partage d\'écran',
				onConfirm: async () => { 
					window.sdk.event().emit('modalClose');
				}
			  }); 
            
			
        })

        window.sdk.event().on('inviteToScreenshare', (device) => {
			if(this.iamLaunchingMyScreenShare)
				return;
            this.iamLaunchingMyScreenShare = true;
            window.sdk.event().emit('modalOpen', {
				variant: 'confirm',
				title: 'Partage d\'écran',
				content: 'Le médecin souhaite que vous partagiez l\'outil ' + device.role,
				onConfirm: async () => { 
					window.sdk.event().emit('modalClose');
					await this.selectTool(device.id, {
						data: device
					});
					this.iamLaunchingMyScreenShare = false;
				},
				onCancel: async () => { 
					window.sdk.event().emit('modalClose');
					window.sdk.videoconf().sendScreenshareInvitationRefuse(device);
					this.iamLaunchingMyScreenShare = false;
				}
			  }); 
            
			
        })

		window.sdk.event().on('screenshareInvitationRefuse', (device) => {
			window.sdk.event().emit('modalOpen', {
				variant: 'alert',
				title: 'Partage d\'écran',
				content: 'Le patient a annulé le partage de l\'outil ' + device.role,
				onConfirm: async () => { 
					window.sdk.event().emit('modalClose');
				}
			  }); 
		});

        let rawDevices = await window.sdk.videoconf().getSpecificDevices(); 
        if(rawDevices)
			this.processRawDevices(rawDevices);

		window.sdk.event().on('screenShareStopped', (device) => {
			let currentDevice = window.sdk.videoconf().getCurrentSpecificDevice();
			if(device && currentDevice && device.id == currentDevice.id) {
				this._closeTool();
			}
		})

		window.sdk.event().on('snapshotRequest', (snapshotType) => {
			if(snapshotType == 'specificDevice')
				this.snapshot(true);
		})

		window.sdk.event().on('specificCurrentDeviceUpdate', (deviceId) => {
			for(var i in this.outils) {
				if(this.outils[i].id == deviceId) {
					if (this.outils[i].role === 'Doc2u') {
						this.startDoc2u(this.outils.find((item) => item.role === 'Doc2u'));
					} else {
						window.sdk.videoconf().setCurrentSpecificDevice(this.outils[i].device.data);
					}
				}
			}
			if(deviceId) {
				this.setState({
					open: true,
					selected: deviceId,
					isRecording: false
				});
			}
			else {
				this.closeDoc2u();
				this.setState({
					open: true,
					selected: '',
					isRecording: false
				});
			}
			if(this.waitingDevice == deviceId){
				this.waitingDevice = false;
				window.sdk.event().emit('modalClose')
			}
		});

		window.sdk.event().on('recordStarted', (deviceId) => {						

			let currentDevice = window.sdk.videoconf().getCurrentSpecificDevice()

			console.log('recordStarted', deviceId, currentDevice);

			if(currentDevice && (deviceId == currentDevice.id || deviceId == currentDevice.dbId)) {
				console.log('recordStarted', 'change isRecording state')
				this.setState({
					recordPendingStart: true
				})
				/*setTimeout(() => {
					
				}, 5000)*/
			}
		})

		window.sdk.event().on('recordStopped', () => {			
			this.setState({
				isRecording: false,
				recordPending: false
			})
		})

		window.sdk.event().on('volumeUpdated', (data) => {
			console.log('volumeUpdated', data);
			console.log('window.sdk.session().session.onetoone.volume_specific', window.sdk.session().session.onetoone.volume_specific);
			this.forceUpdate();
		})

		if(window.sdk.session().isMedecin()) {
			if(window.sdk.session().session.onetoone.current_device) {
				this.setState({
					open: true,
					selected: window.sdk.session().session.onetoone.current_device,
					isRecording: (window.sdk.session().session.onetoone.current_device == window.sdk.session().session.onetoone.recording)
				});
			}
		}

		window.sdk.event().on('recordPending', () => {
			this.setState({
				recordPending: true
			})
		})

		window.sdk.event().on('recordStartedFromServer', () => {
			this.setState({	
				recordPendingStart: false,					
				isRecording: true
			})
		})

		

		window.sdk.event().on('specificDevice', (status, deviceId, deviceInfo, label) => {
			if(label == 'doc2u' || deviceInfo == 'doc2u')
				return;
			try {
				if(window.sdk.session().isMedecin() && this.outils.find((item) => item.role === 'Doc2u').deviceId !== deviceId)
					return;
			}
			catch(err) {
			}
			if(status == 'started') {
				console.log('deviceInfo', deviceInfo, status, deviceId)
				this.setState({
					open: true,
					selected: deviceInfo.id,
					isRecording: false
				});
			}
			if(status == 'stopped') {
				try {
					if (this.outils.find((item) => item.role === 'Doc2u').id === deviceId)
						this.closeDoc2u();
				}
				catch(err) {

				}
				this.setState({
					open: true,
					selected: '',
					isRecording: false
				});
			}
		})
    }

    async startDevice(device) {
        //TODO stop the current specific devices
        return await window.sdk.videoconf().startSpecificDevice(device)
    }

    stopDevice = (deviceId) => {
        window.sdk.videoconf().stopSpecificDevice(deviceId);
    }

	async startDoc2u(device) {
		if (this.state.doc2uActivated)
			return false;
		console.log('-------------------- startDoc2u')
		this.state.doc2uActivated = true;
		let token = await window.sdk.session().getDoc2uRoomToken(window.sdk.session().isPatient())
		device.token = token;
		await window.sdk.event().emit('toggleDoc2u', true, device);	
		if (window.sdk.session().isMedecin()) {
			window.sdk.videoconf().startSpecificDevice(this.outils.find((item) => item.role === 'Doc2u'))
		}
		return true;
	}

	async closeDoc2u() {
		this.state.doc2uActivated = false;
		await window.sdk.event().emit('toggleDoc2u', false, '');
	}

    async startScreenDevice(audio, device) {
        if(window.sdk.session().isMedecin()) {
			this.waitingDevice = device.id;
            window.sdk.videoconf().sendScreenShareInvitation(device);
            window.sdk.event().emit('modalOpen', {
                variant: 'alert',
                title: 'Partage d\'écran',
                content: 'Demande en attente de confirmation',
                onConfirm: () => { 
					this.waitingDevice = false;
                  	window.sdk.event().emit('modalClose')
                },
            });
		}
        else {
			window.sdk.event().emit('loadingStart');
            let res = await window.sdk.videoconf().startScreenShare(audio, device);
			window.sdk.event().emit('loadingStop');
			return res;
		}
    }


	toggle = () => {
		this.setState({
			open: !this.state.open
		});
		if (this.props.onToggle) {
			this.props.onToggle(!this.state.open);
		}
	};

	selectTool = async (item, device, enable) => {
		//TODO put a loader
		if(!enable){
			//TODO swal not conneted
		}

		
		let res;
		console.log('device', device)
		if (device.data.role == "Doc2u") {
			res = await this.startDoc2u(device.data);
		} else if(device.data.screen)
			res = await this.startScreenDevice(device.data.audio, device.data);
		else {					
			res = await this.startDevice(device.data);
		}
		if(!res)
			return;

		window.resizeTo((window.screen.width * 0.63),window.screen.height);	
		window.sdk.videoconf().setCurrentSpecificDevice(device.data);
		this.setState({
			open: true,
			selected: item
		});
	};

	closeTool = () => {
		let currentDevice = window.sdk.videoconf().getCurrentSpecificDevice()
		if(currentDevice.screen) {
			if(window.sdk.session().isMedecin())
				window.sdk.videoconf().requestStopScreenShare();
			else
				window.sdk.videoconf().stopScreenShare();
		}
		else {
			this.closeDoc2u();
			window.sdk.videoconf().stopSpecificDevice(currentDevice.deviceId);
		}
		this._closeTool();
	};

	_closeTool() {
		if(this.state.isRecording)
			window.sdk.videoconf().stopRecord();
		
		window.sdk.videoconf().setCurrentSpecificDevice(false);

		window.resizeTo(window.screen.width, window.screen.height);
		
		
		this.setState({
			open: true,
			selected: '',
			isRecording: false
		});
	}

	snapshot(isRemote) {
		window.sdk.videoconf().executeSnapshot(isRemote);
	}

	record() {		
		if(this.state.recordPending) {
			window.sdk.event().emit('modalOpen', {
				variant: 'alert',
				title: 'Enregistement en cours',
				content: 'Un enregistrement est en cours de finalisation',
				onConfirm: async () => { 
					window.sdk.event().emit('modalClose');					
				}
			});
			return;
		}

		if(this.state.recordPendingStart) {
			window.sdk.event().emit('modalOpen', {
				variant: 'alert',
				title: 'Enregistement en démarrage',
				content: 'Un enregistrement est en cours de démarrage',
				onConfirm: async () => { 
					window.sdk.event().emit('modalClose');					
				}
			});
			return;
		}
		
		console.log('this.state.isRecording', this.state.isRecording);

		if(this.state.isRecording) {
			this.setState({
				isRecording: false
			})
			window.sdk.videoconf().stopRecord();
			return;
		}

		let device = window.sdk.videoconf().getCurrentSpecificDevice();
		console.log('start record of device', device)
		let id = device.id || device.dbId
		let medias = [];
		document.querySelectorAll('.deviceId-' + id).forEach((el, i) => {
			console.log('el', el.getAttribute('data-mediaTag'))
			medias.push(el.getAttribute('data-mediaTag'))
		});

		//let mediaTag = video
		window.sdk.videoconf().startRecord(medias, id);

		
		this.setState({
			recordPendingStart: true
		})
		/*setTimeout(() => {
			console.log('isRecording ok')
			this.setState({						
				recordPendingStart: false,
				isRecording: true
			})
		}, 5000)*/
		//TODO change the status of the record button
	}

	action(type) {
		switch(type) {
			case "camera": //aka snaphot
				this.snapshot();
				break;
			case "record": //aka snaphot
				this.record();
				break;
		}
	}

	onVolumeChange = (icon, value) => {
		console.log('onVolumeChange', icon, value);
		this.finalValue = value;
		if(this.volumentChange)
			return;
		this.volumentChange = setTimeout(() => {			
			this.volumentChange = null;
			let volumeValues = {
				volumeSpecific: window.sdk.session().session.onetoone.volume_specific,
				volumeCam: window.sdk.session().session.onetoone.volume_cam
			}
			icon == 'speaker' ?
				volumeValues['volumeSpecific'] = this.finalValue
			:
				volumeValues['volumeCam'] = this.finalValue;
			window.sdk.videoconf().setVolume(volumeValues);
			window.sdk.event().emit('volumeUpdated');
		}, 300);
	}

	render() {
		const { open, selected, isRecording, recordPending, recordPendingStart } = this.state;

		let slugs = Array.from(new Set(this.outils.map(item => item.slug)));

		let outils = []

		this.outils.forEach(item => {
			if(item.enable)
				outils.push(item);
		});
		slugs.forEach(slug => {
			let count =  outils.filter(item => item.slug === slug).length
			if(count == 0){
				let firstOff = this.outils.find(item => item.slug === slug)
				if(firstOff)
					outils.push(firstOff)
			}
		})
		outils = outils.sort((a, b) => a.order - b.order);
		console.log('outils', outils);
		
		return (
			<div className={'outils' + (open ? ' opened' : '') + ((selected && selected != 0 && selected != '0') ? ' outils--selected' : '')}>
				<div className={'outils__header'} onClick={this.toggle}>
					<i className="icon-chevron-down outils__toggle"></i>
					<h2 className="outils__title">Dispositifs médicaux</h2>
				</div>
				{open && <div className="outils__content">
					<ul className="outils__list">
						{outils.map(({ id, role,slug, iconId, enable, device }) => <li key={'li-' + id} className={'outils__item' + (enable ? ' capteur-show capteur-role-' + slug : ' outils__item--disabled capteur-show capteur-role-' + slug)} onClick={() => this.selectTool(id, device)}>
							<span className="device-item-icon item__icon"><i className={'icon-'+iconId}></i></span> {role}
						</li>)}
					</ul>
					<div className="outils__settings">
						{outils.map(({ id, label, configs, actions, iconId, enable, role, slug }) => {
							if (selected !== id) return null;
							try {
								if (selected === this.outils.find((item) => item.role === "Doc2u").id)
									this.startDoc2u(this.outils.find((item) => item.role === "Doc2u"));
							}
							catch(err) {

							}
							return <div key={id} className={'outils__setting osetting--' + id}>
								<div className="osetting__header">
									<div className="osetting__title">
										<span className="device-item-icon osetting__icon"><i className={'icon-'+iconId}></i></span> {role}
									</div>
									<div className="osetting__close" onClick={this.closeTool}>
										<i className="icon-cancel"></i>
									</div>
								</div>
								{role !== 'Doc2u' && <div className="osetting__content">
									{(configs && configs.length > 0) && (
										<div className="osetting__configs">
											{configs.map(({ type, icon }) => (
												<div key={icon} className={'osetting__config osetting__config--' + type}>
													<IconRange value={ icon == 'speaker' ? window.sdk.session().session.onetoone.volume_specific : window.sdk.session().session.onetoone.volume_cam } onChange={(value) => { this.onVolumeChange(icon, value) }} initial={ icon == 'speaker' ? window.sdk.session().session.onetoone.volume_specific : window.sdk.session().session.onetoone.volume_cam } icon={icon}></IconRange>
												</div>
											))}
										</div>
									)}
									{(actions && actions.length) && (
										<div className="osetting__actions">
											{actions.map(({ type, label }) => (
												<button onClick={(e) => { this.action(type) }} key={type} className={'osetting__action osetting__action--' + type + (type == 'record' && isRecording ? ' osetting__action--active' : '') + (type == 'record' && (recordPending || recordPendingStart) ? ' osetting__action--pending' : '')} title={label}>
													<i className={'icon-' + type}></i>
												</button>
											))}
										</div>
									)}
								</div>}
							</div>
						})}
					</div>
				</div>}
			</div>
		);
	}
}